import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mt-4 border-t" }
const _hoisted_2 = { class: "md:col-span-4 lg:col-span-3" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "col-span-8 p-4" }
const _hoisted_6 = { class: "text-gray-400 text-xs font-semibold" }
const _hoisted_7 = { class: "inline-block" }
const _hoisted_8 = { class: "text-sm text-gray-500" }
const _hoisted_9 = { class: "text-lg font-medium text-gray-900" }

import { watch, ref } from 'vue'
import { useKuromojiStore } from '@/stores/kuromoji'
import { useSearchStore } from '@/stores/search'
import { JapaneseToFurigana } from '@/utils/analysis'
import { Word } from '@/utils/word-types'
import axios from 'axios'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const kuromoji = useKuromojiStore()
const searchStore = useSearchStore()

watch(() => searchStore.selected_word, async (val) => {
  await fetchWord((await kuromoji.tokenize(val))[0].basic_form)
})

const fetchedData = ref<Word[]>()

const fetchWord = async (word: string) => {
  searchStore.setLoading(true)

  await axios.get(`https://dict.vitorvargas.dev/search?keyword=${word}&origin=manabou`)
    .then(res => {
      fetchedData.value = res.data
    })
    .finally(() => {
      searchStore.setLoading(false)
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fetchedData.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "grid sm:grid-cols-1 md:grid-cols-12 my-4 p-4",
        key: item.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          (item.readings[0].kanji)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "japanese text-3xl",
                innerHTML: _unref(JapaneseToFurigana)(item.readings[0].kanji, item.readings[0].kana)
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                textContent: _toDisplayString(item.readings[0].kana),
                class: "japanese text-3xl"
              }, null, 8, _hoisted_4))
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.senses, (sense, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: sense.id,
              class: "mb-4"
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(sense.part_of_speech), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(index + 1) + ". ", 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(sense.definition), 1)
              ])
            ]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}
}

})